export function extendHistory<
    Action,
    Location,
    History extends { action: Action; location: Location },
    AdditionalProps extends {},
>(history: History, additionalProps: AdditionalProps): History & AdditionalProps {
    return {
        ...history,
        ...additionalProps,
        get action() {
            return history.action;
        },
        get location() {
            return history.location;
        },
    };
}
